import { Tag } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";

export default function TagValorConciliacao() {
  return (
    <Tag
      alignSelf="end"
      bg={colors.primaryBlue}
      borderRadius={14}
      color={colors.white}
      fontSize="12px"
      fontWeight={400}
      pt={1}
      pb={1}
      pr={5}
      pl={5}
    >
      Indisponível
    </Tag>
  );
}
